/* src/app/features/cnae-impedido/pesquisa/cnae-impedido-pesquisa.component.scss */
#form-group-check {
  justify-content: space-between;
  align-items: flex-end;
}
/*# sourceMappingURL=cnae-impedido-pesquisa.component.css.map */
